import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-769000b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk" }
const _hoisted_2 = { class: "rk_info" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("机台/工位：")
const _hoisted_4 = { class: "rk_statistics" }
const _hoisted_5 = {
  key: 0,
  class: "rk_statistics_item"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已完工合格品", -1))
const _hoisted_7 = {
  key: 1,
  class: "rk_statistics_item"
}
const _hoisted_8 = { class: "yellow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已完工不良品", -1))
const _hoisted_10 = {
  key: 2,
  class: "rk_statistics_item"
}
const _hoisted_11 = { class: "orange" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "待报废品", -1))
const _hoisted_13 = {
  key: 3,
  class: "rk_statistics_item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "lan" }, "未生产"),
  /*#__PURE__*/_createTextVNode("合格品")
], -1))
const _hoisted_15 = {
  key: 4,
  class: "rk_statistics_item"
}
const _hoisted_16 = { class: "yellow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "lan" }, "未生产"),
  /*#__PURE__*/_createTextVNode("不良品")
], -1))
const _hoisted_18 = {
  key: 5,
  class: "rk_statistics_item"
}
const _hoisted_19 = { class: "grey" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "lan" }, "余留次班生产")
], -1))
const _hoisted_21 = { class: "rk_wl" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_wl_header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rk_wl_header_top" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "rk_wl_header_top_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "完工交接物料")
  ])
], -1))
const _hoisted_23 = {
  key: 0,
  class: "rk_wl_content"
}
const _hoisted_24 = {
  key: 0,
  class: "rk_wl_content_item_a"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("已完工 ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hg" }, "[合格品]", -1))
const _hoisted_27 = {
  key: 1,
  class: "rk_wl_content_item_b"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("已完工 ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bl" }, "[不良品]", -1))
const _hoisted_30 = {
  key: 2,
  class: "rk_wl_content_item_c"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("已完工 ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bf" }, "[待报废]", -1))
const _hoisted_33 = {
  key: 3,
  class: "rk_wl_content_item_d"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nv" }, "未生产", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode()
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hg" }, "[合格品]", -1))
const _hoisted_37 = {
  key: 4,
  class: "rk_wl_content_item_e"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nv" }, "未生产", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bl" }, "[不良品]", -1))
const _hoisted_41 = {
  key: 1,
  class: "rk_sc_kong"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "rk_sc" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_header_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "本次余留次班生产")
], -1))
const _hoisted_46 = {
  key: 0,
  class: "rk_sc_content"
}
const _hoisted_47 = { class: "rk_sc_content_item_a" }
const _hoisted_48 = { class: "rk_sc_content_item_b" }
const _hoisted_49 = {
  key: 0,
  class: "rk_sc_content_item_hz"
}
const _hoisted_50 = { class: "rk_sc_content_item_hz_item_top" }
const _hoisted_51 = { class: "rk_sc_content_item_hz_item_bottom" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ls" }, "未生产", -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode()
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "succ" }, "[合格品]", -1))
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ls" }, "未生产", -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode()
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "err" }, "[不合格]", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_sc_kong" }, [
  /*#__PURE__*/_createElementVNode("span", null, "暂无数据")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_zw" }, null, -1))
const _hoisted_62 = { class: "rk_footer" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("完工入库")
const _hoisted_64 = [
  _hoisted_63
]

import { ref, onMounted, onBeforeUnmount } from 'vue'
  import { Toast } from 'vant'
  import { useRouter, useRoute } from "vue-router"
  import { finishedDetail, finished } from '@/apis/WorkOrderAPI'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()

  const router = useRouter()

  let info: any = ref([])

  // 完工入库提交
  const submit = () => {
      // if (window.sessionStorage.getItem('ids')) {
          let deviceIds: any = route.query.ids
          finished({
              deviceIds: deviceIds ? deviceIds : '',
              inIds: window.sessionStorage.getItem('ids') ? window.sessionStorage.getItem('ids') : ''
          }).then(res => {
              if (res.code === 200) {
                  Toast.success({
                      message: '入库成功',
                      duration: 2000,
                      forbidClick: true
                  })
                  setTimeout(() => {
                    // router.go(-1)
                    router.replace({ path: '/workbench' })
                  }, 2000)
              }
          })
      // } else {
      //     Toast({ message: '请先选择余留次班' })
      // }

  }

  // 获取详情
  const finishedDetails = (ids: any) => {
      finishedDetail({
          deviceIds: route.query.ids,
          inIds: ids ? ids : ''
      }).then(res => {
          if (res.code === 200) {
              console.log(res)
              info.value = res.data
          }
      })
  }

  // 跳转预留班次
  const jump = () => {
    // if (window.sessionStorage.getItem('ids')) {
    //   router.push({ name: 'secondShift', query: { id: info.value.produceLocationIds, ids: window.sessionStorage.getItem('ids') } })
    // } else {
      router.push({ name: 'secondShift', query: { id: info.value.produceLocationIds } })
    // }
  }

  onMounted(() => {

      finishedDetails(window.sessionStorage.getItem('ids'))

  })

  onBeforeUnmount(() => {

      if (window.sessionStorage.getItem('ids')) {
          window.sessionStorage.removeItem('ids')
      }

  })

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "作业员：" + _toDisplayString(_unref(info).worker) + "/" + _toDisplayString(_unref(info).groupName), 1),
      _createElementVNode("span", null, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).deviceList, (item, i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.name) + " " + _toDisplayString(i === _unref(info).deviceList.length - 1 ? '' : '/'), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(info).finishedQualified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(info).finishedQualified.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).finishedQualified.boxNum) + "盒", 1),
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (_unref(info).finishedUndesirable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(info).finishedUndesirable.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).finishedUndesirable.boxNum) + "盒", 1),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_unref(info).finishedScrap)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(info).finishedScrap.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).finishedScrap.boxNum) + "盒", 1),
            _hoisted_12
          ]))
        : _createCommentVNode("", true),
      (_unref(info).qualified)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_unref(info).qualified.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).qualified.boxNum) + "盒", 1),
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      (_unref(info).undesirable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(info).undesirable.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).undesirable.boxNum) + "盒", 1),
            _hoisted_17
          ]))
        : _createCommentVNode("", true),
      (_unref(info).surplus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(info).surplus.num), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(info).surplus.boxNum) + "盒", 1),
            _hoisted_20
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      (_unref(info).appliancesMaterialBeanList && _unref(info).appliancesMaterialBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).appliancesMaterialBeanList, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "rk_wl_content_item",
                key: i
              }, [
                _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                (item.finishedQualified && item.finishedQualified.boxNum > 0 && item.finishedQualified.num > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _createTextVNode("：" + _toDisplayString(item.finishedQualified.boxNum) + "盒｜" + _toDisplayString(item.finishedQualified.num) + _toDisplayString(item.finishedQualified.unitName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.finishedUndesirable && item.finishedUndesirable.boxNum > 0 && item.finishedUndesirable.num > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                      _hoisted_28,
                      _hoisted_29,
                      _createTextVNode("：" + _toDisplayString(item.finishedUndesirable.boxNum) + "盒｜" + _toDisplayString(item.finishedUndesirable.num) + _toDisplayString(item.finishedUndesirable.unitName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.finishedScrap && item.finishedScrap.boxNum > 0 && item.finishedScrap.num > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                      _hoisted_31,
                      _hoisted_32,
                      _createTextVNode("：" + _toDisplayString(item.finishedScrap.boxNum) + "盒｜" + _toDisplayString(item.finishedScrap.num) + _toDisplayString(item.finishedScrap.unitName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.qualified && item.qualified.boxNum > 0 && item.qualified.num > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _createTextVNode("：" + _toDisplayString(item.qualified.boxNum) + "盒｜" + _toDisplayString(item.qualified.num) + _toDisplayString(item.qualified.unitName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.undesirable && item.undesirable.boxNum > 0 && item.undesirable.num > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _createTextVNode("：" + _toDisplayString(item.undesirable.boxNum) + "盒｜" + _toDisplayString(item.undesirable.num) + _toDisplayString(item.undesirable.unitName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
    ]),
    _createElementVNode("div", _hoisted_44, [
      _hoisted_45,
      (_unref(info).finishedInBillBeanList && _unref(info).finishedInBillBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).finishedInBillBeanList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "rk_sc_content_item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(item.code), 1),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", null, "接收人：" + _toDisplayString(item.userName) + "/" + _toDisplayString(item.departmentName), 1),
                  _createElementVNode("span", null, "时间：" + _toDisplayString(item.dealDate), 1)
                ]),
                (item.appliancesMaterialBeanList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.appliancesMaterialBeanList, (item1, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "rk_sc_content_item_hz_item",
                          key: idx
                        }, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("span", null, _toDisplayString(item1.materialName) + " | " + _toDisplayString(item1.materialCode), 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            (item1.qualified)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                  _hoisted_53,
                                  _hoisted_54,
                                  _hoisted_55,
                                  _createTextVNode("：" + _toDisplayString(item1.qualified.boxNum) + "盒｜" + _toDisplayString(item1.qualified.num) + _toDisplayString(item1.qualified.unitName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item1.undesirable)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                  _hoisted_57,
                                  _hoisted_58,
                                  _hoisted_59,
                                  _createTextVNode("：" + _toDisplayString(item1.undesirable.boxNum) + "盒｜" + _toDisplayString(item1.undesirable.num) + _toDisplayString(item1.undesirable.unitName), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_60
    ]),
    _hoisted_61,
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", {
        class: "rk_footer_s",
        onClick: jump
      }, "余留次班"),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "rk_footer_u",
        onClick: submit
      }, _hoisted_64)), [
        [_directive_preventReClick]
      ])
    ])
  ]))
}
}

})